import React from "react";
import { Row, Col } from "react-bootstrap";

import { FORM_FIELD_KEYS } from "../../../../constants/forms";
import { getFieldProps } from "../../../../utils/form-fields";

import TextInput from "../../../controls/TextInput";
import MaskInput from "../../../controls/MaskInput";
import Select from "../../../controls/Select";

function ResponsiblePartyInfoBlock({ values = {}, onChange }) {
  return (
    <Row>
      <Col xs={12}>
        <div className="inputs-block-title">
          <span>Responsible Party Information</span>
        </div>
      </Col>
      <Col xs={12} md={6}>
        <Select
          {...getFieldProps(FORM_FIELD_KEYS.responsiblePartyTitle)}
          value={values[FORM_FIELD_KEYS.responsiblePartyTitle]}
          validated={values.validated}
          onChange={onChange}
        />
      </Col>
      <Col xs={12} md={6}>
        <TextInput
          {...getFieldProps(FORM_FIELD_KEYS.responsiblePartyFirstName)}
          value={values[FORM_FIELD_KEYS.responsiblePartyFirstName]}
          onChange={onChange}
        />
      </Col>
      <Col xs={12} md={6}>
        <TextInput
          {...getFieldProps(FORM_FIELD_KEYS.responsiblePartyMiddleName)}
          value={values[FORM_FIELD_KEYS.responsiblePartyMiddleName]}
          onChange={onChange}
        />
      </Col>
      <Col xs={12} md={6}>
        <TextInput
          {...getFieldProps(FORM_FIELD_KEYS.responsiblePartyLastName)}
          value={values[FORM_FIELD_KEYS.responsiblePartyLastName]}
          onChange={onChange}
        />
      </Col>
      <Col xs={12} md={6}>
        <Select
          {...getFieldProps(FORM_FIELD_KEYS.responsiblePartySuffixName)}
          value={values[FORM_FIELD_KEYS.responsiblePartySuffixName]}
          validated={values.validated}
          onChange={onChange}
        />
      </Col>
      <Col xs={12} md={6}>
        <MaskInput
          {...getFieldProps(FORM_FIELD_KEYS.responsiblePartySSN)}
          value={values[FORM_FIELD_KEYS.responsiblePartySSN]}
          onChange={onChange}
        />
      </Col>
      <Col xs={12}>
        <div className="inputs-block-divider" />
      </Col>
    </Row>
  );
}

export default ResponsiblePartyInfoBlock;
